import axios from "axios";
import React, { useState } from "react";
import { ChatState } from "../../Context/ChatProvider";
import UserBadgeItem from "../userAvatar/UserBadgeItem";
import UserListItem from "../userAvatar/UserListItem";
import ConfirmModal from "./ConfirmModal/ConfirmModal";
import Closeicon from "../../images/Closeicon";
import SpinnerCustom from "../SpinnerCustom";
import { getAuthConfig} from "../../utils/functions";

const UpdateGroupChatModal = ({ fetchMessages, fetchAgain, setFetchAgain }) => {
    const [groupChatName, setGroupChatName] = useState();
    const [search, setSearch] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [renameloading, setRenameLoading] = useState(false);

    const { selectedChat, setSelectedChat, user, openProfileModal, setOpenProfileModal, showToast, chats } = ChatState();
    const [isOpenModal, setIsOpenModal] = useState(false); //modal Window Skynix
    const [isOpenModalRename, setIsOpenModalRename] = useState(false);
    const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
    const [userForAddDelete, setUserForAddDelete] = useState("");
    const onCloseModal =()=> {
        setIsOpenModal(false);
        setIsOpenModalRename(false);
        setIsOpenModalDelete(false);
        setUserForAddDelete("");
    }
    const handleSearch = async (query) => {
        if (query.match(/[<>&]/)) {
            showToast('warning', 'Please avoid using <, >, & characters.'    );
            return 
        }
        setSearch(query.replace(/[<> &]/g, ''));
        if (!query) {
            return;
        }

        try {
            if(query.length < 6) {
                setSearchResult([]);
                return;
            }
            setLoading(true);
            const config = {
                headers: { Authorization: `Bearer ${user.token}`},
            };
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/user?search=${search}`, config);
            setLoading(false);
            setSearchResult(data);
        } catch (error) {
            showToast ('danger',  'Error Occured! Failed to Load the Search Results.' );
            setLoading(false);
        }
    };
    const handleRenameGross =()=> {
        setIsOpenModalRename(true);
    }
    const handleRename = async () => {
        if (!groupChatName) return;
        if (selectedChat.groupAdmin._id !== user._id) {
            showToast ( 'info', 'Only admin can add/remove/change someone!'  );
            return; 
        }
        const chatNameExist = chats.find(chatName => chatName.chatName === groupChatName);
        if (chatNameExist) {
            showToast ('warning', 'This name is already is in DataBase. Choose another');
            return;
        }
        try {
            setRenameLoading(true);
            const config = getAuthConfig(user.token);
            const { data } = await axios.put(
                `${process.env.REACT_APP_API_URL}/api/chat/rename`,
                {
                    chatId: selectedChat._id,
                    chatName: groupChatName
                },
                config
            );
            showToast (
                'success', 'This change was successfull!'
            );
            setSelectedChat(data);
            setFetchAgain(!fetchAgain);
            setRenameLoading(false);
        } catch (error) {
            if (error.response && error.response.status === 403) {
                showToast("warning","Session security issue. Redirect to login...");
                localStorage.removeItem("userInfo");
                setTimeout(() => { window.location.href = "/login"; }, 2000);
            } else {
                showToast ('danger', 'Error Occured! Failed to create/change/delete group' );
                console.log("Error Occured!", error.response.data.message);
            }
            setRenameLoading(false);
        }
        setGroupChatName("");
    };
    const handleAddUserGross =(user)=>{
        setIsOpenModal(true);
        setUserForAddDelete(user);
    }
    const handleAddUser = async (user1) => {
        if (selectedChat.users.find((u) => u._id === user1._id)) {
            showToast ('warning', 'The user is already in this group. Choose next one' );//checked
            return;
        }
        if (selectedChat.groupAdmin._id !== user._id) {
            showToast ('warning', 'Only admin can add/remove/change someone!' );
            return;
        }

        try {
            setLoading(true);
            const config = getAuthConfig(user.token);
            const { data } = await axios.put(
                `${process.env.REACT_APP_API_URL}/api/chat/groupadd`,
                {
                    chatId: selectedChat._id,
                    userId: user1._id,
                },
                config
            );
            showToast ( 'success', 'New user added/created!'     );
            setSelectedChat(data);
            setFetchAgain(!fetchAgain);
        } catch (error) {
            console.log("Error Occured! ", error.response.data.message);
            showToast ('danger', 'Error Occured! New user is not added' );
        } finally {
            setLoading(false);
        }
        setGroupChatName("");
    };
//delete 1 group-participant
    const handleRemoveUserGross =(user)=> {
        setIsOpenModalDelete(true);
        setUserForAddDelete(user)
    }
    const handleRemoveUser = async (user1) => {
        if (selectedChat.groupAdmin._id !== user._id && user1._id !== user._id) {
            showToast ('info', 'Only admin can add/remove/change someone!  ');
            return;
        }
        if (selectedChat.groupAdmin._id === user1._id) {   //Only for Admin delete
            setIsOpenModalDelete(true);
            alert(" setIsOpenModalDelete(true);");
                try {
                    setLoading(true);
                    const config = getAuthConfig(user.token);
                    await axios.post(
                        `${process.env.REACT_APP_API_URL}/api/chat/deletegroup`,
                        {
                            chatId: selectedChat._id
                        },
                        config
                    );
                    showToast ( 'success', `Chat   ${selectedChat.chatName} deleted successfully!` );
                    setOpenProfileModal(false);
                    // setFetchAgain(!fetchAgain);
                    fetchMessages();
                } catch (error) {
                    showToast ('danger', error.res || 'Failed to delete the chat.' );
                } finally {
                    setLoading(false);
                }
        } else {
                try {
                    setLoading(true);
                    const config = getAuthConfig(user.token);
                    const { data } = await axios.put(
                        `${process.env.REACT_APP_API_URL}/api/chat/groupremove`,
                        {
                            chatId: selectedChat._id,
                            userId: user1._id
                        },
                        config
                    );
                    user1._id === user._id ? setSelectedChat() : setSelectedChat(data);
                    showToast ('success', "User removed from the group.");
                    setFetchAgain(!fetchAgain);
                    fetchMessages();
                } catch (error) {
                    const message = error.response?.data?.message 
                                    || error.message 
                                    || "Network error: Check your connection or API URL";
                    console.error("Group remove error details:", {
                        url: error.config?.url,
                        method: error.config?.method,
                        status: error.response?.status,
                        message: message
                    });
                    showToast('danger', `Error: ${message}`);
                } finally {
                    setLoading(false);  
                }
        }        
        setGroupChatName("");
        setIsOpenModal(false);
        setIsOpenModalDelete(false);
    };
    const setAndCheckGroupChatName = (e) => {
        if (e.match(/[<>&]/)) {
            showToast('warning', 'Please avoid using <, >, & characters.'    ); 
            setGroupChatName(e.replace(/[<> &]/g, ''));
            return
        }   else {
            setGroupChatName(e);    
        }
    }

    return (
        <>
            <button type='button' className='group_icon_button' onClick={()=>setOpenProfileModal(true)} >
                <div className='group_avatar'>
                    <img className='imgAvatar'  src={selectedChat.groupAdmin.pic} alt='imgAvatar'/>
                    <div className='chat_item-image-images carousel'>
                        {/* {selectedChat.users.map((user, i) => {
                            if(user.name === selectedChat.groupAdmin.name) { shift = shift + 1; return} //man muss add let shift = 0;
                            return <img style={{left: `${(-i*2 + shift*2 + '0px')}`}} key={i}  className='chat_item-image-images-image' src={user.pic} alt='groupMember'/>
                        })} */}
                        {selectedChat.users?.filter(user => user.name !== selectedChat.groupAdmin.name).slice(0, 5).map((user, i) => (
                            <img    key={user._id || i}
                                    style={{ left: `${-i * 20}px` }} 
                                    className='chat_item-image-images-image' 
                                    src={user.pic} 
                                    alt='groupMember'
                            />
                        ))}
                    </div>
                </div>
            </button>
            < ConfirmModal onConfirm={()=>handleRename()} isOpen={isOpenModalRename} onClose={onCloseModal} content = {`Do you want to rename group to ${groupChatName}?`}/>
            < ConfirmModal onConfirm={()=>handleAddUser(userForAddDelete)} isOpen={isOpenModal} onClose={onCloseModal} content = {`Do you want to add new group user ${userForAddDelete.name}?`}/>
            < ConfirmModal onConfirm={()=>handleRemoveUser(userForAddDelete)} isOpen={isOpenModalDelete} onClose={onCloseModal} content = {`Do you want to remove group admin and the whole group?`}/>
            { openProfileModal && <div className='modalContent Time' >
                <div className='modalOverlay'></div>
                <div className='modalContentTime' role='dialog' tabindex='-1' aria-modal='true'>
                    <div className='modal_header'>
                        {selectedChat.chatName}
                    </div>
                    <button className='close_button' onClick={()=>setOpenProfileModal(false)}><Closeicon /></button>
                    <div className='modal_body'>
                        <div className='badgeBlock' >
                            {selectedChat.users.map((u) => (
                                <UserBadgeItem
                                    key={u._id}
                                    user={u}
                                    admin={selectedChat.groupAdmin}
                                    handleFunction={() => handleRemoveUser(u)}
                                />
                            ))}
                        </div>
                        <div className='updateBlock'>
                            <input
                                placeholder="Chat Name"
                                className='updateInput'
                                value={groupChatName}
                                onChange={(e) => setAndCheckGroupChatName(e.target.value)}
                            />
                            <button
                                className='update_button button'
                                isLoading={renameloading}
                                onClick={handleRenameGross}
                            >
                                Update
                            </button>
                        </div>
                        <div className='updateBlock'>
                            <input
                                placeholder="Add User to group"
                                className='updateInput'
                                onChange={(e) => handleSearch(e.target.value)}
                                value={search}
                            />
                            <div className='charakters_left' style={{ 
                                    left: (search.length > 2 && search.length < 7) ? `${search.length * 17}px` : 0, 
                                    display: (search.length > 2 && search.length < 6) ? "block" : "none"
                                }} variant="ghost"  >
                                <i className="fas fa-search"></i>
                                <p className = 'searchUser'>
                                    {6 - search.length + " more characters"}
                                </p>
                            </div>
            
                        </div>

                        {loading ? (
                            <SpinnerCustom />
                        ) : (
                            searchResult?.map((user) => (
                                <UserListItem
                                    key={user._id}
                                    user={user}
                                    handleFunction={() => handleAddUserGross(user)}
                                />
                            ))
                        )}
                    </div>
                    <div className='update_footer'>
                        <button className=' button update_button' onClick={() => handleRemoveUserGross(user)} >
                            Leave Group
                        </button>
                    </div>
                </div>
            </div> }
        </>
    );
};

export default UpdateGroupChatModal;
